import React, { Component } from 'react';
import {CSVLink} from 'react-csv';
export default class WordSearchStatistics extends Component {
  render() {
    return (
            <p className="lead">
            <span>Documents: {this.props.stats.items}</span>{'; '}
            <span>Types: {this.props.stats.types}</span>{'; '}
            <span>Tokens: {this.props.stats.tokens}</span>{' '}
            <CSVLink
              data={this.props.data}
              style={{color: 'white'}}
              filename={"DAMOS-search.csv"}
              className="btn btn-sm btn-success pull-right"
              target="_blank">Download as csv</CSVLink>
            </p>
)
  }
}

/* da er json file under src
    const bla = da.hits.reduce((acc, item) => {
       const ja = Object.keys(item).reduce(function (newObj, key) {
        let val = item[key];
        newObj[key.charAt(0).toUpperCase() + key.slice(1)] = val;
        return newObj;

    }, {});
    acc.push(ja)
    return acc;
    }, []);
    */



// WEBPACK FOOTER //
// ./src/components/wordsearchscreens/WordSearchStatisticsSimple.js